import { useQuery } from "react-query";
import { AppConstant, KeyConstant } from "@/const";
import { PaginationType } from "@/types/common";
import { PersonService } from "@/services";
import dayjs from "dayjs";

export type IdSearchFilterValue = {
  identification?: string;
  start?: Date | null;
  end?: Date | null;
};

export type IdSearchPayloadType = {
  paginationParam: Partial<PaginationType>;
  filterParam: IdSearchFilterValue;
};

const useIdSearchList = (props: IdSearchPayloadType) => {
  const { paginationParam, filterParam } = props;
  const { page, size } = paginationParam || {};
  const { identification, start, end } = filterParam || {};

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [KeyConstant.REACT_QUERY.getPersonList, page, size, filterParam],
    queryFn: () => {
      return PersonService.getPersonList({
        page: page || 1,
        size: size || AppConstant.DEFAULT_SIZE_PAGE,
        identification: identification ? identification : "",
        start_time: start ? dayjs(start)?.valueOf() : undefined,
        end_time: end ? dayjs(end)?.valueOf() : undefined,
      });
    },
  });

  const { data: requestList, ...pagination } = data || {};

  return {
    requestList: requestList || [],
    pagination: (pagination as PaginationType) || {},
    isLoading,
    isError,
    refetch,
  };
};

export default useIdSearchList;
